import React, { useRef, useState } from 'react';
import _ from 'lodash';
import Icon from 'components/base/Icon';
import * as S from './TabsClipboard.styles';
import EditableText from './EditableText';
import useIsScrollableRef from 'components/hooks/useIsScrollableRef';
import useScroll, { SCROLL_DIRECTIONS } from 'components/hooks/useScroll';

const TabsArrow = ({ isDisplay, direction, icon, scrollRef }) => (
  <S.ScrollArrow
    direction={direction}
    isDisplay={isDisplay}
    onClick={() => scrollRef.scroll({ direction })}
    onMouseDown={() => scrollRef.startAutoScroll({ direction })}
    onMouseUp={() => scrollRef.stopAutoScroll()}
  >
    <Icon name={icon} size='small' color='nepal' />
  </S.ScrollArrow>
);

const Tab = ({ tab = {}, isSelected, onClick }) => {
  const { logo, title, key } = tab;
  return (
    <S.Tab onClick={() => onClick(key)} isSelected={isSelected}>
      {logo && <img className='logo' src={logo} />}
      <div className='title'>{title}</div>
    </S.Tab>
  );
};

const EditableValueLine = ({ value, onRemove, onEdit }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <S.ValueLine
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <EditableText value={value} onEdit={value => onEdit(value)} />
      <Icon
        name='Close'
        size='small'
        color='nepal'
        visibility={isHover ? 'visible' : 'hidden'}
        onClick={onRemove}
      />
    </S.ValueLine>
  );
};

const TabsClipboards = ({
  tabs = [],
  selectedKey,
  onTabClick,
  onRemoveValue,
  onEditValue
}) => {
  const tabsWrapperRef = useRef();
  const { x: isTabsScrollable } = useIsScrollableRef({
    ref: tabsWrapperRef,
    dependencies: [tabs.length]
  });
  const scrollTabs = useScroll(tabsWrapperRef);

  const tabsKeys = _.keyBy(tabs, 'key');
  const selectedTab = _.get(tabsKeys, selectedKey);
  const values = _.get(selectedTab, 'data', []);

  return (
    <S.TabsClipboards>
      <header>
        <TabsArrow
          isDisplay={isTabsScrollable}
          direction={SCROLL_DIRECTIONS.LEFT}
          icon='ChevronLeft'
          scrollRef={scrollTabs}
        />

        <S.TabsWrapper ref={tabsWrapperRef} data-cy='clipboard-tabs'>
          {tabs.map((tab, i) => {
            const key = _.get(tab, 'key');
            const isSelected = key === selectedKey;
            return (
              <Tab
                key={key}
                tab={tab}
                isSelected={isSelected}
                onClick={onTabClick}
              />
            );
          })}
        </S.TabsWrapper>

        <TabsArrow
          isDisplay={isTabsScrollable}
          direction={SCROLL_DIRECTIONS.RIGHT}
          icon='ChevronRight'
          scrollRef={scrollTabs}
        />
      </header>
      <main>
        {values.map((value, idx) => (
          <EditableValueLine
            key={idx}
            value={value}
            onRemove={() => onRemoveValue(selectedKey, value)}
            onEdit={newValue => onEditValue(selectedKey, value, newValue)}
          />
        ))}
      </main>
    </S.TabsClipboards>
  );
};

export default TabsClipboards;
